import { render } from "./BusZuliZhiJianEditForm.vue?vue&type=template&id=10d39fe6&scoped=true"
import script from "./BusZuliZhiJianEditForm.vue?vue&type=script&lang=js"
export * from "./BusZuliZhiJianEditForm.vue?vue&type=script&lang=js"

import "./BusZuliZhiJianEditForm.vue?vue&type=style&index=0&id=10d39fe6&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d39fe6"]])

export default __exports__